// extracted by mini-css-extract-plugin
module.exports = {"modalParent":"Modal_modalParent__8Y2MS","modalParent2":"Modal_modalParent2__0y1Sr"};